import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const PolygonIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M17.8166 20.4174H6.50001L2.90918 9.49463L12.1583 3.00586L21.4074 9.49463L17.8166 20.4174Z"
        stroke="#5AB8F1"
        strokeWidth="1.5"
      />
      <rect x="1" y="7.48828" width="3.71942" height="3.69663" rx="1.84832" {...svgAttrs} />
      <rect x="4.48193" y="18.3027" width="3.71942" height="3.69663" rx="1.84832" {...svgAttrs} />
      <rect x="15.7986" y="18.3027" width="3.71942" height="3.69663" rx="1.84832" {...svgAttrs} />
      <rect x="10.1404" y="1" width="3.71942" height="3.69663" rx="1.84832" {...svgAttrs} />
      <rect x="19.2805" y="7.48828" width="3.71943" height="3.69663" rx="1.84832" {...svgAttrs} />
    </svg>
  );
};

export default PolygonIcon;
